export default {
    when() {
        return document.querySelectorAll('.cursor').length > 0;
    },

    mounted() {
        const cursor = $('.cursor');

        $(window).on('mousemove', function(e) {
            cursor.css({
                top: e.clientY - cursor.height() / 2,
                left: e.clientX - cursor.width() / 2
            });
        });

        $('.has-cursor')
            .on('mouseenter', function() {
                cursor.removeClass('hidden');
            })
            .on('mouseleave', function() {
                cursor.addClass('hidden');
            });
    },
};

